import { render } from "./project_setting.vue?vue&type=template&id=d7c9263a&scoped=true"
import script from "./project_setting.vue?vue&type=script&lang=js"
export * from "./project_setting.vue?vue&type=script&lang=js"

import "./project_setting.vue?vue&type=style&index=0&id=d7c9263a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c9263a"]])

export default __exports__